import { Modal } from "@/components";
import { useDebouncedListSearch } from "@/hooks";
import { ResourceName } from "@/utils";
import { Close, ExpandMore, Search } from "@mui/icons-material";
import {
  Button,
  Chip,
  CircularProgress,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { useIsFetching } from "@tanstack/react-query";
import { FC, useState } from "react";
import { TopToolbar as RaTopToolbar, useListContext } from "react-admin";
import { PaymentsFilter } from "../../modals/payments-filter/payments-filter.component";
import { FiltersList } from "./filters-list.component";

const sortFieldToColName = (field: string) => {
  switch (field) {
    case "createdAt":
      return "Created";
    case "price":
      return "Amount";
    case "status":
      return "Status";
    case "type":
      return "Type";
    case "paidAt":
      return "Paid";
    default:
      return field;
  }
};

const TopToolbar: FC = () => {
  const { sort } = useListContext();
  const [searchQuery, setSearchQuery] = useDebouncedListSearch();

  const isFetching = useIsFetching({
    queryKey: [ResourceName.USER_PURCHASES, "getList"],
  });

  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);

  return (
    <>
      <Modal
        title="Filters"
        isOpened={isFiltersModalOpen}
        onClose={() => setIsFiltersModalOpen(false)}
        children={
          <PaymentsFilter onModalClose={() => setIsFiltersModalOpen(false)} />
        }
      />

      <RaTopToolbar
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          marginTop: 1,
          paddingRight: 0,
        }}
      >
        <Stack
          direction="row"
          sx={{ width: "100%", justifyContent: "space-between" }}
        >
          <Chip
            size="small"
            variant="filled"
            label={`Sorted by: ${sortFieldToColName(sort.field)} (${sort.order})`}
          />

          <Stack direction="row" spacing={1}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search by user"
              sx={{ width: "220px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              slotProps={{ htmlInput: { maxLength: 50 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {!!isFetching && <CircularProgress size={16} />}
                    {!isFetching && !!searchQuery && (
                      <Close
                        sx={{ cursor: "pointer" }}
                        onClick={() => setSearchQuery("")}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <Button
              size="small"
              endIcon={<ExpandMore />}
              sx={{ minWidth: "auto" }}
              onClick={() => setIsFiltersModalOpen(true)}
            >
              Filters
            </Button>
          </Stack>
        </Stack>

        <FiltersList />
      </RaTopToolbar>
    </>
  );
};

export { TopToolbar };
